import { defineMessages } from 'react-intl';

const trns = defineMessages({
  verified: {
    id: 'qPKtSb',
    defaultMessage: 'Перевірено нашим фахівцем {date}'
  },
  experience: {
    id: 'sdDSVH',
    defaultMessage: 'Стаж {experience} роки'
  }
});

export default trns;
